import { ErrorsWrapper } from 'ui-builder';

export default ErrorsWrapper;
